import React from "react";
import Box from "@sendsprint/ui-react/components/box";
import Typography from "@sendsprint/ui-react/components/typography";
import Button from "@sendsprint/ui-react/components/button";
import clsx from "clsx";

interface Props {
  icon?: React.FunctionComponent<React.SVGAttributes<SVGElement>>;
  title: string;
  subtitle: string;
  variant?: "light" | "dark";
  handleResetPostSubmitState: () => void;
  background?: "deep-green" | "light-green";
}

const MailingListResponse = ({
  icon: Icon,
  title,
  subtitle,
  variant = "dark",
  handleResetPostSubmitState,
  background,
}: Props) => (
  <Box className="ss:flex ss:flex-col ss:items-center">
    {Icon && <Icon className="ss:inline-block ss:mb-12 ss:max-w-25" />}
    <Typography
      as="h2"
      variant="h5"
      className={clsx("ss:text-center", {
        "ss:text-neutral-50": variant === "light",
      })}
    >
      {title}
    </Typography>
    <Typography
      className={clsx("ss:mt-4 ss:mb-3 ss:font-normal ss:text-center", {
        "ss:text-neutral-50": variant === "light",
      })}
      as="h5"
    >
      {subtitle}
    </Typography>
    <Button
      label="Close"
      onClick={handleResetPostSubmitState}
      variant={background === "deep-green" ? "secondary" : "primary"}
      size="small"
      className="ss:px-20"
    />
  </Box>
);

export default MailingListResponse;
